import { SERVICE } from '@ds/swymkit/tools'
import { dsFetch } from '@ds/swymkit/tools'
import { servicesAuth } from '@ds/swymkit/tools'
import { handleCsrfError } from '@ds/swymkit/tools'
import { removeRequestId } from '@ds/swymkit/tools'
import { serviceProxy } from '@ds/swymkit/tools'

/** Ky instance proxified on 3DSearch service */
export const searchFetch = dsFetch.extend({
  hooks: {
    beforeRequest: [
      removeRequestId,
      serviceProxy(SERVICE.SEARCH),
    ],
    afterResponse: [
      (...args) => handleCsrfError(SERVICE.SEARCH, searchFetch)(...args),
      (...args) => servicesAuth(searchFetch, dsFetch)(...args),
    ],
  },
})
